/* eslint-disable react/no-danger */
import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from './AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'dialog']);
interface LoginWithAtlassianProps {
  aaEmail: string;
  orgName: string;
  onDismiss: () => void;
  onClick: () => void;
  image?: HTMLImageElement;
}

export const LoginWithAtlassian: FunctionComponent<LoginWithAtlassianProps> = ({
  image,
  aaEmail,
  orgName,
  onDismiss,
  onClick,
}) => (
  <OnboardingDialog
    title={format('sounds good')}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    closeDialog={onDismiss}
    image={image}
  >
    <p
      dangerouslySetInnerHTML={{
        __html: format('managed account message', {
          transferBoardsUrl: AtlassianAccountOnboardingLinks.TransferBoards,
        }),
      }}
    />
    <div>
      <p>{format('primary email message')}</p>
    </div>
    <div className={styles.primaryEmail}>{aaEmail}</div>

    <p
      dangerouslySetInnerHTML={{
        __html: format('log in with Atlassian', {
          org: orgName,
          atlassianAccountUrl: AtlassianAccountOnboardingLinks.AtlassianAccount,
        }),
      }}
    />
    <div className={styles.section}>
      <form action="/first_aa_login" method="post">
        <input type="hidden" name="provider" value="atlassian" />
        <input type="hidden" name="returnUrl" value={location.pathname} />
        <PrimaryButton type="submit" onClick={onClick}>
          {format('log in with Atlassian button')}
        </PrimaryButton>
      </form>
    </div>
  </OnboardingDialog>
);
